// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-avatar .v-image__image--cover,.custom-avatar picture{width:100%;height:100%;-o-object-fit:cover;object-fit:cover;background-size:contain}", ""]);
// Exports
module.exports = exports;
